import { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionHeading } from "@/components/Section";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FaqPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/faq").then((r) => setItems(r.data)).catch(() => {}); }, []);
  const cats = [...new Set(items.map((f) => f.category))];
  return (
    <div className="section-lux grid-glow">
      <div className="container-lux max-w-3xl">
        <SectionHeading label="FAQ" title="Frequently Asked Questions" />
        <div className="mt-10 space-y-8">
          {cats.map((cat) => (
            <div key={cat}>
              <h3 className="text-lg font-semibold text-amber-400 mb-3">{cat}</h3>
              <Accordion type="single" collapsible>
                {items.filter((f) => f.category === cat).map((f) => (
                  <AccordionItem key={f.id} value={f.id} className="card-lux mb-3 px-5 border-none">
                    <AccordionTrigger className="text-left text-white hover:no-underline" data-testid={`faq-${f.id}`}>{f.question}</AccordionTrigger>
                    <AccordionContent className="text-slate-400">{f.answer}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
